import {Component, OnInit} from '@angular/core';
import {Tab} from "@sbzen/ng-cron";
import {MatDialogRef} from "@angular/material/dialog";
import {animate, style, transition, trigger} from "@angular/animations";
import {DataService} from "../../../../services/data.service";
import {FormGroup} from "@angular/forms";
import cronstrue from "cronstrue";

@Component({
  selector: 'app-cron',
  templateUrl: './cron.component.html',
  styleUrls: ['./cron.component.scss'],
  animations: [
    trigger('dialog', [
      transition('void => *', [
        style({transform: 'scale3d(.3, .3, .3)'}),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({transform: 'scale3d(.0, .0, .0)'}))
      ])
    ])
  ]
})
/**
 * Component to manage cron-expression input from user.
 */
export class CronComponent implements OnInit {

  cronExpression: string = "* * * ? * * *";
  tabs = [Tab.DAY, Tab.MONTH];
  activeTab = Tab.DAY;
  transitTimeValueOptions : string[];
  threshold: number = 20;
  transitTimeValue: string= "ALL";
  cronForm: FormGroup;
  help_messages: any = this.dataService.help_messages;

  constructor(
    private dialogRef: MatDialogRef<CronComponent>,
    public dataService: DataService
  ) {
  }

  ngOnInit(): void {
    this.transitTimeValueOptions = this.dataService.transitTimeValueOptions;
  }

  getInHumanReadableForm() {
    return cronstrue.toString(this.cronExpression).split(',').slice(1).join(',').toUpperCase();
  }

  submitCronValue() {
    this.closeEvent(this.cronExpression)
  }

  closeEvent(cronExpression = null) {
    let metadata = {
      "transitTime" : this.transitTimeValue,
      "threshold": this.threshold,
      "cronExpression": cronExpression,
      "cronDescriptor": this.getInHumanReadableForm()
    }
    this.dialogRef.close(metadata)
  }
}
